import { render, staticRenderFns } from "./CalendarSingleEvent.vue?vue&type=template&id=2b31e890"
import script from "./CalendarSingleEvent.vue?vue&type=script&lang=js"
export * from "./CalendarSingleEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports